import { motion } from "framer-motion";
import type { ElementType, ReactNode } from "react";

import { useReducedMotionSafe } from "@/hooks/useReducedMotionSafe";
import { STAGGER_STEP, staggerGroup, staticVariants, viewportOnce } from "@/lib/motion";

interface StaggerGroupProps {
  children: ReactNode;
  className?: string;
  /** Versatz zwischen den Kindern in Sekunden. */
  step?: number;
  /** Verzögerung vor dem ersten Kind. */
  delay?: number;
  as?: ElementType;
}

/**
 * REGEL: Gruppen (Karten, Listen, Zahlen) erscheinen gestaffelt.
 * Kinder müssen <Reveal> oder motion-Elemente mit den Varianten
 * "hidden"/"visible" sein; die Steuerung kommt von hier.
 */
const StaggerGroup = ({
  children,
  className,
  step = STAGGER_STEP,
  delay = 0,
  as = "div",
}: StaggerGroupProps) => {
  const reduced = useReducedMotionSafe();
  const MotionTag = motion(as as ElementType);

  return (
    <MotionTag
      className={className}
      variants={reduced ? staticVariants : staggerGroup(step, delay)}
      initial="hidden"
      whileInView="visible"
      viewport={viewportOnce}
    >
      {children}
    </MotionTag>
  );
};

export default StaggerGroup;
